import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Globe, Copy, Check, Loader2 } from 'lucide-react';
import { api } from '../lib/api';

// Admin affordance: opt the comp's public spectator page in/out and copy the
// share link. Default is OFF (gamertags are personal data — publishing is a
// deliberate choice).
export function PublicPageToggle({ compId, enabled }: { compId: string; enabled: boolean }) {
  const qc = useQueryClient();
  const [copied, setCopied] = useState(false);

  const mut = useMutation({
    mutationFn: (next: boolean) => api.setCompPublicPage(compId, next),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['competitions'] }),
  });

  const watchUrl = `${window.location.origin}/watch/${encodeURIComponent(compId.replace(/^COMP#/, ''))}`;

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => mut.mutate(!enabled)}
        disabled={mut.isPending}
        className={`flex items-center gap-2 rounded-lg px-3 py-2 text-xs font-semibold uppercase tracking-wider transition-colors disabled:opacity-50 ${
          enabled
            ? 'bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/[0.16]'
            : 'bg-white/[0.06] text-ink-secondary hover:bg-white/[0.1] hover:text-ink-primary'
        }`}
        title={enabled ? 'Public spectator page is LIVE — click to unpublish' : 'Publish a read-only spectator page anyone can watch without logging in'}
      >
        {mut.isPending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Globe className="h-3.5 w-3.5" />}
        {enabled ? 'Public · Live' : 'Make public'}
      </button>
      {enabled && (
        <button
          onClick={() => { navigator.clipboard.writeText(watchUrl).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); }).catch(() => {}); }}
          className="flex items-center gap-1.5 rounded-lg bg-white/[0.06] px-3 py-2 text-xs font-semibold uppercase tracking-wider text-ink-secondary transition-colors hover:bg-white/[0.1] hover:text-ink-primary"
          title={watchUrl}
        >
          {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? 'Copied' : 'Copy link'}
        </button>
      )}
    </div>
  );
}
